"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FbApiScope = void 0;
// reference - https://developers.facebook.com/docs/permissions/reference/
var FbApiScope;
(function (FbApiScope) {
    FbApiScope["ADS_MANAGEMENT"] = "ads_management";
    FbApiScope["ADS_READ"] = "ads_read";
    FbApiScope["ATTRIBUTION_READ"] = "attribution_read";
    FbApiScope["CATALOG_MANAGEMENT"] = "catalog_management";
    FbApiScope["BUSINESS_MANAGEMENT"] = "business_management";
    FbApiScope["EMAIL"] = "email";
    FbApiScope["GAMING_USER_LOCALE"] = "gaming_user_locale";
    FbApiScope["GROUPS_ACCESS_MEMBER_INFO"] = "groups_access_member_info";
    FbApiScope["INSTAGRAM_BASIC"] = "instagram_basic";
    FbApiScope["INSTAGRAM_CONTENT_PUBLISH"] = "instagram_content_publish";
    FbApiScope["INSTAGRAM_MANAGE_COMMENTS"] = "instagram_manage_comments";
    FbApiScope["INSTAGRAM_MANAGE_INSIGHTS"] = "instagram_manage_insights";
    FbApiScope["INSTAGRAM_MANAGE_MESSAGES"] = "instagram_manage_messages";
    FbApiScope["LEADS_RETRIEVAL"] = "leads_retrieval";
    FbApiScope["MANAGE_PAGES"] = "manage_pages";
    FbApiScope["PAGE_EVENTS"] = "page_events";
    FbApiScope["PAGES_MANAGE_ADS"] = "pages_manage_ads";
    FbApiScope["PAGES_MANAGE_CTA"] = "pages_manage_cta";
    FbApiScope["PAGES_MANAGE_ENGAGEMENT"] = "pages_manage_engagement";
    FbApiScope["PAGES_MANAGE_INSTANT_ARTICLES"] = "pages_manage_instant_articles";
    FbApiScope["PAGES_MANAGE_METADATA"] = "pages_manage_metadata";
    FbApiScope["PAGES_MANAGE_POSTS"] = "pages_manage_posts";
    FbApiScope["PAGES_MESSAGING"] = "pages_messaging";
    FbApiScope["PAGES_READ_ENGAGEMENT"] = "pages_read_engagement";
    FbApiScope["PAGES_READ_USER_CONTENT"] = "pages_read_user_content";
    FbApiScope["PAGES_SHOW_LIST"] = "pages_show_list";
    FbApiScope["PAGES_USER_GENDER"] = "pages_user_gender";
    FbApiScope["PAGES_USER_LOCALE"] = "pages_user_locale";
    FbApiScope["PAGES_USER_TIMEZONE"] = "pages_user_timezone";
    FbApiScope["PUBLISH_PAGES"] = "publish_pages";
    FbApiScope["PUBLIC_PROFILE"] = "public_profile";
    FbApiScope["PUBLISH_TO_GROUPS"] = "publish_to_groups";
    FbApiScope["PUBLISH_VIDEO"] = "publish_video";
    FbApiScope["READ_INSIGHTS"] = "read_insights";
    FbApiScope["RESEARCH_APIS"] = "research_apis";
    FbApiScope["USER_AGE_RANGE"] = "user_age_range";
    FbApiScope["USER_BIRTHDAY"] = "user_birthday";
    FbApiScope["USER_FRIENDS"] = "user_friends";
    FbApiScope["USER_GENDER"] = "user_gender";
    FbApiScope["USER_HOMETOWN"] = "user_hometown";
    FbApiScope["USER_LIKES"] = "user_likes";
    FbApiScope["USER_LINK"] = "user_link";
    FbApiScope["USER_LOCATION"] = "user_location";
    FbApiScope["USER_MESSENGER_CONTACT"] = "user_messenger_contact";
    FbApiScope["USER_PHOTOS"] = "user_photos";
    FbApiScope["USER_POSTS"] = "user_posts";
    FbApiScope["USER_VIDEOS"] = "user_videos";
})(FbApiScope = exports.FbApiScope || (exports.FbApiScope = {}));
//# sourceMappingURL=fbApiScope.enum.js.map